import React from 'react'
import Navbar from "./Navbar"
import userData from '../userData'
import Footer from './Footer'
import "../css/aboutUs.css"



function AboutUs() {
    return (
        <div>
            <Navbar
                userImg={userData[0].userImg}
            />
            <div className="aboutUs">
                <h2 className="about-heading ">We believe that animals have rights and deserve to live their best life</h2>
                <p className="about-para">At PetMe, we are dedicated to making pet adoption accessible, transparent, and fulfilling, facilitating the bond between humans and animals.
                    <br />Our platform simplifies the pet adoption process, bringing together reputable shelters, rescue groups, and individuals. Connecting pets in need with loving homes.
                    <br />Find your perfect companion easily whether you're an experienced pet owner or considering adoption for the first time, we're here to support you every step of the way with our user-friendly platform. Our dedicated team is ready to assist you with any questions or concerns, ensuring a smooth and positive adoption journey.
                    <br />Let's make a difference in the lives of these incredible animals and create a world where every pet finds a loving home.</p>
            </div>

            <section id="aboutUs-cards">

                <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                    <div class="carousel-inner">

                        <div class="carousel-item active">
                            <div className="aboutUs-div">
                                <div className="aboutUs-pic slide-1-pic" ></div>
                                <div className="aboutUs-card-content">
                                    <h3 className="aboutUs-card-heading">Who We Are</h3>
                                    <p className="aboutUs-card-para">We are here to empower pets, their owners and coming generations.</p>
                                </div>
                            </div>
                        </div>

                        <div class="carousel-item">
                            <div className="aboutUs-div">
                                <div className="aboutUs-pic slide-2-pic"></div>
                                <div className="aboutUs-card-content">
                                    <h3 className="aboutUs-card-heading">What We Do</h3>
                                    <p className="aboutUs-card-para">Our devoted team of staff and volunteers has been the reason behind our remarkable achievements, from making this website to uniting thousands of pets and their owners.</p>
                                </div>
                            </div>
                        </div>

                        <div class="carousel-item">
                            <div className="aboutUs-div">
                                <div className="aboutUs-pic slide-3-pic"></div>
                                <div className="aboutUs-card-content">
                                    <h3 className="aboutUs-card-heading">Making A Difference</h3>
                                    <p className="aboutUs-card-para">Together we created awareness about this issue of pets getting treated the way they shouldn't and day by day more people are joining us.</p>
                                </div>
                            </div>
                        </div>

                        <div class="carousel-item">
                            <div className="aboutUs-div">
                                <div className="aboutUs-pic slide-4-pic"></div>
                                <div className="aboutUs-card-content">
                                    <h3 className="aboutUs-card-heading">Our Work Around The Nation</h3>
                                    <p className="aboutUs-card-para">Our work across the nation enables us to create big, positive and sustainable changes in pets welfare.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"><i class="fa-solid fa-arrow-left"></i></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"><i class="fa-solid fa-arrow-right"></i></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>

            </section>

            <Footer />
        </div>
    )
}

export default AboutUs